import constant from '../constants/gameConstant';

export const gameInitialState = {
    searchResult: {
        data: null,
        error: null,
        isLoading: false
    },
    addResult: {
        data: null,
        error: null,
        isLoading: false
    },
    shouldResult: {
        data: null,
        error: null,
        isLoading: false
    },
    getResult: {
        data: null,
        error: null,
        isLoading: false
    },
    platformResult: {
        data: null,
        error: null,
        isLoading: false
    },
    paginateResult: {
        data: null,
        error: null,
        isLoading: false
    },
    addListResult: {
        data: null,
        error: null,
        isLoading: false
    }
}

export function gameReducer(state, action) {

    switch (action.type) {

        case constant.ADD_REQUEST:
            return {
                ...state,
                addResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.ADD_SUCCESS:
            return {
                ...state,
                addResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.ADD_FAIL:
            return {
                ...state,
                addResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.GET_REQUEST:
            return {
                ...state,
                getResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.GET_SUCCESS:
            return {
                ...state,
                getResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.GET_FAIL:
            return {
                ...state,
                getResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.GET_PLATFORMS_REQUEST:
            return {
                ...state,
                platformResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.GET_PLATFORMS_SUCCESS:
            return {
                ...state,
                platformResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.GET_PLATFORMS_FAIL:
            return {
                ...state,
                platformResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.SEARCH_REQUEST:
            return {
                ...state,
                searchResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.SEARCH_SUCCESS:
            return {
                ...state,
                searchResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.SEARCH_FAIL:
            return {
                ...state,
                searchResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.PAGINATE_REQUEST:
            return {
                ...state,
                paginateResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.PAGINATE_SUCCESS:
            return {
                ...state,
                paginateResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                },
                gameDetailId: gameInitialState.gameDetailId
            };

        case constant.PAGINATE_FAIL:
            return {
                ...state,
                paginateResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.SHOULD_REQUEST:
            return {
                ...state,
                shouldResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.SHOULD_SUCCESS:
            return {
                ...state,
                shouldResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.SHOULD_FAIL:
            return {
                ...state,
                shouldResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.ADD_LIST_REQUEST:
            return {
                ...state,
                addListResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.ADD_LIST_SUCCESS:
            return {
                ...state,
                addListResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.ADD_LIST_FAIL:
            return {
                ...state,
                addListResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.RESET:
            return {
                ...state,
                addResult: gameInitialState.addResult,
                gameDetailId: gameInitialState.gameDetailId,
                getResult: gameInitialState.getResult,
                paginateResult: gameInitialState.paginateResult,
                platformResult: gameInitialState.platformResult,
                searchResult: gameInitialState.searchResult,
                shouldResult: gameInitialState.shouldResult
            };

        default:
            return state;
    }
}

export default gameReducer;
